export default "__VITE_ASSET__Ji1JqJjC__"